import React, {useCallback, useEffect, useState} from 'react';
import {useDispatch} from "react-redux";
import ScrollLayout from "../../../../components/ScrollLayout";
import {ComponentNoData} from "../../../../components/ComponentLoader";
import ViewAllTitle from "../../../../components/ViewAllTitle";
import {
  loadFeaturedList,
  loadFlashSaleList,
  loadFreshSpecialList,
  loadHotSpecialList, loadNothing, loadProductListByValueAndType,
} from '../../../../redux/slices/dynamicMultipleElementsSlice'
import ProductCard from "./ProductCard";
import ProductLoader, {ProductError} from "./ProductLoader";
import {PRODUCT_LIST_TYPE} from "../../../../constants/commons";
import {getProductList} from "../../../../redux/sagas/requests/productService";

const ProductListUi = (
  {
    productData: {
      loading = false, data = [],
      init = false, error = "", hasNext = true
    } = {},
    type = PRODUCT_LIST_TYPE.hot,
    value,
    title = "",
    className = "",
    titleSpacing,
    viewButtonColor,
    hasViewAllBtn,
    mobile,
    isCampaign,
    isNavOverlay
  }) => {

  const dispatch = useDispatch();

  useEffect(() => {
    if (!init && !loading && !error)
      dispatch(getProductListLoader(type)({type, value}));
  }, [dispatch, init, loading, error, type, value]);

  const loadMore = useCallback(
    (force) => {
      if (force || (hasNext && !loading && !error))
        dispatch(getProductListLoader(type)({type, value}));
    },
    [hasNext, loading, error, value]
  );


  return (
    <ProductListUiDesign type={type} mobile={mobile} hasViewAllBtn={hasViewAllBtn} title={title} className={className}
                         value={value} isCampaign={isCampaign} titleSpacing={titleSpacing}
                         viewButtonColor={viewButtonColor} loadMore={loadMore} isNavOverlay={isNavOverlay}
                         productData={{data, loading, error, init, hasNext}}/>

  );
};

export default React.memo(ProductListUi);

export const ProductListUiNoRedux = (
  {
    type = PRODUCT_LIST_TYPE.hot,
    value,
    title = "",
    className = "",
    titleSpacing,
    viewButtonColor,
    hasViewAllBtn,
    mobile,
    isCampaign,
    isNavOverlay
  }) => {

  const [fetchedData, setFetchedData] = useState({
    loading: false, data: [], page: 0,
    init: false, error: "", hasNext: true
  });

  useEffect(async () => {
    loadData().then();

  }, []);

  const loadData = async (force) => {
    if (force || (fetchedData.hasNext && !fetchedData.loading && !fetchedData.error)) {
      try {
        setFetchedData({...fetchedData, loading: true, error: ""});

        const {data: {page, has_next: hasNext, data}}
          = await getProductList({page: (fetchedData?.page ?? 0) + 1, type, value});
        setFetchedData({
          ...fetchedData, data: [...fetchedData.data, ...data], hasNext, page, init: true, loading: false
        });
      } catch (error) {
        const errMsg = error.response ? error.response.data.message : error.message;
        setFetchedData({...fetchedData, error: errMsg, loading: false});
      }
    }
  };

  return (
    <ProductListUiDesign type={type} mobile={mobile} hasViewAllBtn={hasViewAllBtn} title={title} className={className}
                         value={value} isCampaign={isCampaign} titleSpacing={titleSpacing} isNavOverlay={isNavOverlay}
                         viewButtonColor={viewButtonColor} loadMore={loadData}
                         productData={fetchedData}/>

  );
};

const ProductListUiDesign = (
  {
    productData: {
      loading = false, data = [],
      init = false, error = "", hasNext = true
    } = {},
    type = PRODUCT_LIST_TYPE.hot,
    value,
    title = "",
    className = "",
    titleSpacing,
    viewButtonColor,
    hasViewAllBtn,
    mobile,
    isCampaign,
    loadMore,
    isNavOverlay
  }) => {

  return (
    <div
      className={`w-full text-rand-100 grid-area min-w-0 box-border${className ? ` ${className}` : ''}${mobile ? "" : " web px-5"}`}>
      <ViewAllTitle title={title}
                    className={`${titleSpacing ? `${titleSpacing} ` : ''}${isCampaign && !title ? (mobile ? "h-[78px] pt-5 mb-2.5 mt-0" : "h-[100px] pt-6 mb-4 mt-0") : "mt-0"}`}
                    viewButtonColor={viewButtonColor} mobile={mobile} hasViewAllBtn={hasViewAllBtn}/>
      {(init && !data.length) ?
        <ComponentNoData
          msg={type === PRODUCT_LIST_TYPE.sale || type === PRODUCT_LIST_TYPE.hot || type === PRODUCT_LIST_TYPE.fresh
            ? 'No items added to this list. (this section wont be visible in the app)' : 'No data'}/> :

        <ScrollLayout className="product-list space-x-2" onScroll={loadMore} showNav={!mobile}
                      classNav="mx-8 blog-product-nav" isNavOverlay={isNavOverlay}>

          {data.map((product, i) => <ProductCard mobile={mobile} product={product}
                                                 key={`${product.product_id}-${i}-${type}`}
                                                 isFlashSale={type === PRODUCT_LIST_TYPE.sale}/>)}

          {Array.from({length: !init && !error ? 10 : loading ? 2 : 0}, (_, i) =>
            <ProductLoader key={`specials-loader-${type}-${i}`} mobile={mobile}
                           isFlashSale={type === PRODUCT_LIST_TYPE.sale}/>)}
          {error && <ProductError retry={() => loadMore(true)} errorMsg={error}/>}

        </ScrollLayout>}


    </div>

  );
};

const getProductListLoader = (type) => {
  if (type === PRODUCT_LIST_TYPE.hot)
    return loadHotSpecialList;
  else if (type === PRODUCT_LIST_TYPE.fresh)
    return loadFreshSpecialList;
  else if (type === PRODUCT_LIST_TYPE.featured)
    return loadFeaturedList;
  else if (type === PRODUCT_LIST_TYPE.sale)
    return loadFlashSaleList;
  else if (type === PRODUCT_LIST_TYPE.BRAND || type === PRODUCT_LIST_TYPE.CATEGORY || type === PRODUCT_LIST_TYPE.PRODUCT_CAMPAIGN || type === PRODUCT_LIST_TYPE.OTHER)
    return loadProductListByValueAndType;

  return loadNothing
};
